import { useState } from "react";

import emailjs from "@emailjs/browser";

// import { db } from "../../util/firebase";
// import { collection, addDoc } from "firebase/firestore";

import Swal from "sweetalert2";

import BarLoader from "react-spinners/BarLoader";
import { Button } from "reactstrap";

import { useTranslation } from "react-i18next";

function ContactPage() {
  const { t } = useTranslation("common");

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const [contactFormEmail, setContactFormEmail] = useState();
  const [contactFormMessage, setContactFormMessage] = useState();

  const sendContactForm = async () => {
    if (contactFormEmail && contactFormMessage) {
      setIsLoading(true);

      const serviceId = "sportleague_outlook";
      const adminTemplateId = "contactFormAdmin";
      const userTemplateId = "contactFormUser";
      const publicKey = "Ki5BETKiWrS6RDEP_";

      const templateParams = {
        contactFormEmail,
        contactFormMessage,
      };

      await emailjs
        .send(serviceId, adminTemplateId, templateParams, publicKey)
        .then(
          (response) => {
            console.log("SUCCESS!", response.status, response.text);
          },
          (error) => {
            console.log("FAILED...", error);
          }
        );

      await emailjs
        .send(serviceId, userTemplateId, templateParams, publicKey)
        .then(
          (response) => {
            console.log("SUCCESS!", response.status, response.text);
          },
          (error) => {
            console.log("FAILED...", error);
          }
        );

      // await addDoc(collection(db, "mail"), {
      //   to: [
      //     'info@sportleague.net'
      //   ],
      //   message: {
      //     subject: 'You have a new message!',
      //     html: `Hi! You have a new message from ${contactFormEmail} who says:<br/>
      //           ${contactFormMessage}<br/><br/>
      //           Best regards,<br/>
      //           Sport League`
      //   }
      // });

      // await addDoc(collection(db, "mail"), {
      //   to: [
      //     contactFormEmail
      //   ],
      //   message: {
      //     subject: 'Recibimos tu mensaje',
      //     html: `Hola! Gracias por tu interes en Sport League!<br/>
      //           Recibimos tu mensaje y estaremos respondiendote cuanto antes.<br/><br/>
      //           Saludos,<br/>
      //           Sport League`
      //   }
      // });

      Swal.fire({
        text: "Contact form submitted",
        icon: "success",
        confirmButtonColor: "#005EE1",
        confirmButtonText: "OKAY",
      });

      setContactFormEmail();
      setContactFormMessage();

      setIsLoading(false);
    } else {
      Swal.fire({
        text: "Please enter your email and message",
        icon: "warning",
        confirmButtonColor: "#005EE1",
        confirmButtonText: "OKAY",
      });
    }
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="contactPage" className="page">
      <h1>{t("contactUs").toUpperCase()}!</h1>
      <p style={{ color: "#FFFFFF" }}>
        {t("feelFreeToReachOutIfYouHaveAnyQuestionsOrJustWantToConnectWithUs")}
      </p>
      <input
        type="text"
        className="mainInput"
        value={contactFormEmail}
        onChange={(e) => setContactFormEmail(e.target.value)}
        placeholder={t("enterYourEmail")}
        style={{ marginBottom: "0.5rem" }}
      />
      <textarea
        className="mainInput"
        value={contactFormMessage}
        onChange={(e) => setContactFormMessage(e.target.value)}
        placeholder={t("enterYourMessage")}
        style={{
          marginBottom: "0.5rem",
          height: 150,
          borderRadius: 20,
          paddingTop: "1rem",
        }}
      ></textarea>
      <Button
        onClick={sendContactForm}
        className="primaryBtn"
        style={{ width: "100%" }}
      >
        {t("send").toUpperCase()}
      </Button>
    </div>
  );
}

export default ContactPage;
